/* Keep the existing cart countdown, running only while the drawer is open. */
(function () {
  'use strict';
  var duration = 10 * 60 * 1000;
  var deadline = 0;
  var interval = null;

  function readDeadline() {
    var cookie = document.cookie.split('; ').find(function (value) {
      return value.indexOf('timerCart=') === 0;
    });
    return cookie ? Number(cookie.slice('timerCart='.length)) : 0;
  }

  function tick() {
    var timer = document.getElementById('timer');
    if (!timer) { stop(); return; }
    var now = Date.now();
    if (!Number.isFinite(deadline) || deadline <= now) {
      deadline = now + duration;
      document.cookie = 'timerCart=' + deadline + '; Max-Age=86400; Path=/; SameSite=Lax';
    }
    var seconds = Math.ceil((deadline - now) / 1000);
    timer.textContent = 'YOUR ORDER IS RESERVED FOR ' +
      String(Math.floor(seconds / 60)).padStart(2, '0') + ':' +
      String(seconds % 60).padStart(2, '0');
  }

  function stop() {
    if (interval !== null) clearInterval(interval);
    interval = null;
  }

  function syncReservationNotice() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var notice = drawer && drawer.querySelector('[data-cart-reservation]');
    if (!notice) return false;

    var hasItems = drawer.querySelectorAll('[data-items-holder] [data-cart-item]').length > 0;
    notice.classList.toggle('hidden', !hasItems);
    notice.hidden = !hasItems;
    if (!hasItems) stop();
    return hasItems;
  }

  function cartChanged() {
    if (syncReservationNotice() && document.querySelector('[data-cart-drawer].is-open')) {
      start();
    }
  }

  function start() {
    stop();
    if (!syncReservationNotice()) return;
    if (!document.getElementById('timer')) return;
    deadline = readDeadline();
    tick();
    interval = setInterval(tick, 1000);
  }

  function observeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(syncReservationNotice).observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('theme:cart:open', start);
  document.addEventListener('theme:cart:close', stop);
  ['theme:cart:loaded', 'theme:cart:added', 'theme:cart:update'].forEach(function (eventName) {
    document.addEventListener(eventName, cartChanged);
  });
  observeCartDrawer();
  syncReservationNotice();
})();
